import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $type?: 'list' | 'card' | string;
  $mainColor?: string;
  $textColor?: string;
}

export const CouponItem = styled.div<IProps>`
  position: relative;

  .btn {
    ${mixin.flex({ align: 'center', justify: 'flex-start' })}
    width: 100%;
    height: 100%;

    > svg g {
      fill: ${props => props.$textColor};
    }
  }

  .bg-wrap {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;

    svg {
      width: 100%;
      height: 100%;

      path {
        fill: ${props => props.$mainColor};
      }
    }
  }

  .text-wrap {
    width: 100%;
    z-index: 1;

    .text {
      color: ${props => props.$textColor};
    }
  }

  ${props => {
    switch (props.$type) {
      case 'list':
        return css`
          width: 290px;
          height: 60px;

          .text-wrap {
            padding: 12px 20px;

            .title {
              font-weight: 500;
              font-size: 15px;
              line-height: 130%;
              ${mixin.ellipsis(1)};
            }

            .desc {
              margin-top: 2px;
              line-height: 130%;
            }
          }
        `;
      case 'card':
        return css`
          width: 140px;
          height: 132px;

          .btn {
            flex-direction: column;

            > svg {
              width: 12px;
              height: 13px;
              margin-top: 8px;
              z-index: 1;
            }
          }

          .text-wrap {
            height: 100px;
            padding: 17px 16px;

            .title {
              font-weight: 600;
              font-size: 16px;
              line-height: 22px;
              ${mixin.ellipsis(2)};
              margin-bottom: 8px;
            }

            .desc {
              font-weight: 400;
            }
          }
        `;
      default:
        return null;
    }
  }}

  @media ${({ theme }) => theme.media.smMax} {
    ${props => {
      switch (props.$type) {
        case 'list':
          return css`
            width: ${mixin.pxToVw('290')};
            height: ${mixin.pxToVw('60')};

            .text-wrap {
              padding: ${mixin.pxToVw('12 20')};

              .title {
                font-size: ${mixin.pxToVw('15')};
              }

              .desc {
                margin-top: ${mixin.pxToVw('2')};
              }
            }
          `;
        case 'card':
          return css`
            width: ${mixin.pxToVw('140')};
            height: ${mixin.pxToVw('132')};

            .btn {
              > svg {
                width: ${mixin.pxToVw('12')};
                height: ${mixin.pxToVw('13')};
                margin-top: ${mixin.pxToVw('8')};
              }
            }

            .text-wrap {
              height: ${mixin.pxToVw('100')};
              padding: ${mixin.pxToVw('17 16')};

              .title {
                font-size: ${mixin.pxToVw('16')};
                line-height: ${mixin.pxToVw('22')};
                margin-bottom: ${mixin.pxToVw('8')};
              }
            }
          `;
        default:
          return null;
      }
    }}
  }

  @media ${({ theme }) => theme.media.pc} {
    ${props => {
      switch (props.$type) {
        case 'list':
          return css`
            width: 380px;
            height: 68px;

            .text-wrap {
              padding: 12px 40px 12px 24px;

              .title {
                font-size: 18px;
              }

              .desc {
                margin-top: 4px;
                font-size: 13px;
                font-weight: 400;
              }
            }
          `;
        case 'card':
          return css`
            width: 190px;
            height: 180px;

            .btn {
              > svg {
                width: 17px;
                height: 20px;
                margin-top: 9px;
              }
            }

            .text-wrap {
              height: 137px;
              padding: 22px 28px 22px 22px;

              .title {
                font-size: 24px;
                line-height: 30px;
                margin-bottom: 12px;
              }

              .desc {
                font-size: 15px;
                line-height: 20px;
              }
            }
          `;
        default:
          return null;
      }
    }}
  }
`;
